import { MenuItem } from "@szhsin/react-menu";

import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

const CalendarEventMenu = ({ externalUrl }: { externalUrl: string }) => (
  <MenuItem
    className={"text-sm flex items-center"}
    href={externalUrl}
    target="_blank"
    onClick={({ syntheticEvent }) => {
      syntheticEvent.preventDefault();
      syntheticEvent.stopPropagation();
      window.open(externalUrl, "_blank");
    }}
  >
    <TopicflowIcon type="calendar" className="mr-3 h-4 w-4 text-gray-400" />
    View Calendar Event
  </MenuItem>
);

export default CalendarEventMenu;
